module.exports = __webpack_public_path__ + "img/unsub-logo-icon.f3cbfe61.png";